/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2015 Adobe Systems Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe Systems Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Adobe Systems Incorporated and its
 * suppliers and are protected by all applicable intellectual property
 * laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe Systems Incorporated.
 **************************************************************************/

/**
 * Simple singleton style utility container so all utility related
 * stuff has a centralized wrapper.
 */
window.iaw = window.iaw || { };

window.iaw.util = {

	currentBreakPoint: 0,
	loadingLibrary: false, // flag indicates cc library is in loading or not
	libraryCallbacks: [],
	ccxProcessLaunchPending: false,


	/**
	* Get current time
	*/
	getCurrentTime: function() {
		var currentTime = new Date().getTime();
		return currentTime;
	},
	/**
	 * Determine if the current browser is running on a MS Windows based OS.
	 *
	 * @return A boolean value indicating true if the browser is on Windows,
	 *          false otherwise.
	 */
	isWindowsOS: function() {

		return ( navigator.userAgent.indexOf('Mac OS X') === -1 );
	},

	/**
	 * Convert a URL parameter string into an object.
	 *
	 * @return A object with key/value members created from the URL string.
	 */
	convertQueryString: function( search ) {

		// build out the JS object - note: this does not handle sub-objects (like the 'overrides' one)
		var jsObj =  { };

		if ( search ) {
			// remove hash before parsing the query
			var idx = search.indexOf('#');

			if (idx !== -1) {
				search = search.slice(0, idx);
			}

			var jsData = '{"' + search.replace(/&/g, '","').replace(/=/g, '":"') + '"}';

			jsObj = JSON.parse(jsData, function(key, value) {

				var val = (key === '' ? value : decodeURIComponent(value));

				// check for numeric values & boolean - otherwise assume string
				if (isNaN( val )) { // boolean, or possibly a string
					if (val !== 'true') {
						val = (val !== 'false') ? val /* its a string */ : false;
					}
					else {
						val = true;
					}
				}
				else {  // numeric
					val = parseFloat(val);
				}

				return val;
			});
		}

		return jsObj;
	},

	/**
	 * Convert query string into an object. New one because the above throws an error and it's easier to write a new one than to debug the old one.
	 * Usually you'll just want to pass in `location.hash`
	 *
	 * @return A object with key/value members created from the URL string.
	 */
	parseQueryString: function(str) {
		var ret = Object.create(null); // object with no proto so it won't break with bad param

		if (typeof str !== 'string') {
			return ret;
		}

		str = str.trim().replace(/^(\?|#|&)/, '');

		if (!str) {
			return ret;
		}

		str.split('&').forEach(function(param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;

			key = decodeURIComponent(key);

			// missing `=` should be `null`:
			val = val === undefined ? null : decodeURIComponent(val);

			if (ret[key] === undefined) {
				ret[key] = val;
			}
			else if (Array.isArray(ret[key])) {
				ret[key].push(val);
			}
			else {
				ret[key] = [ret[key], val];
			}
		});

		return ret;
	},

	/**
	 * Download image.
	 * @param url        url to download
	 * @param callback   completion callback method with the parameter of blob or null if any failure.
	 */
	downLoadImage: function( url, callback ) {

		iaw.log.debug( 'Downloading image from: ' + url );
		var xhr = new XMLHttpRequest( );

		xhr.onreadystatechange = function() {
			if ( this.readyState === 4 && this.status === 200 ) {
				iaw.log.debug( 'Image is downloaded.' );
				callback( this.response );
			}
		};
		xhr.onerror  = function( error ) {
			callback( null );
		};
		xhr.open( 'GET', url, true );
		xhr.responseType = 'blob';
		xhr.send( );
	},

	/**
	 * Setup ajax request.
	 * @param url        url to download
	 * @param callback   completion callback method with the parameter of blob or null if any failure.
	 */
	ajax: function( url, callback, scope ) {
		var xhr = new XMLHttpRequest();

		xhr.onreadystatechange = function() {
			if ( this.readyState === 4 && this.status === 200 ) {
				callback.call(scope || null, this.response);
			}
		};

		xhr.onerror = function( error ) {
			iaw.log.debug('[util.ajax] Error');
			callback.call(scope || null, error);
		};
		xhr.open('GET', url, true);
		xhr.send();
	},

	/**
	 *
	 */
	normalize: function(v, min, max) {

		return (v - min) / (max - min);
	},

	/**
	 * Open a URL in the default browser.
	 *
	 * @param url string containing the URL to load
	 */
	openDefaultBrowser: function( url, isAuthenticated ) {

		isAuthenticated = isAuthenticated || false;

		// skip the authenticated URL's because they dont mean anything... we want the base
		if ( !isAuthenticated ) {
			iaw.analytics.pip.logInteractionEvent( 'OpenExtLink:' + url );
		}
		if ( window.cep.util.openURLInDefaultBrowser ) {
			window.cep.util.openURLInDefaultBrowser(url);
		}
		else {
			window.open(url, '_blank');
		}
	},

	/**
	 * Similar to openDefaultBrowser but uses creates an authenicated
	 * jump url.
	 *
	 * @param clientKey		element key that matches entry in iaw.cepUtil.authenticationInfo
	 * @param url			string containing the URL to open
	 */
	openDefaultBrowserAuthenicated: function( clientKey, url ) {

		if ( iaw.cepUtil.imsValid() ) {
			var query = url.indexOf('?');

			iaw.analytics.pip.logInteractionEvent( 'OpenExtLink:' + url.substr(0, (query > 0) ? query : url.length) );

			var callback = function(authenticatedURL) { //eslint-disable-line func-style
				iaw.log.console('The generated jumpURL is: ' + authenticatedURL);
				iaw.util.openDefaultBrowser( authenticatedURL, true );
			};
			this.jumpToURL( iaw.cepUtil.authenticationInfo[clientKey].clientID,
							iaw.cepUtil.authenticationInfo[clientKey].clientScope,
							url, callback );
		}
		else {
			this.openDefaultBrowser( url );
		}
	},

	/**
	 * Set the UI theme mode.
	 *
	 * @param mode          color mode, 'light' or 'dark'
	 */
	setUIThemeMode: function( mode ) {

		switch ( mode ) {
			case 'light':
				document.body.classList.remove('spc--dark');
				break;

			case 'dark':
				document.body.classList.add('spc--dark');
				break;

			default:
				// get the interface color -- if CEP is not present -
				// submit to the dark side cause its cooler...
				var interfaceColor = ( iaw.cepUtil.csInterface ) ? iaw.cepUtil.getUIThemeColor() : null;

				this.setUIThemeMode( (interfaceColor && interfaceColor.red >= 184) ? 'light' : 'dark' );
				break;
		}
	},

	/**
	 * Method to generate a jump url. Only for CEP based applications. This method
	 * will make a callback to deal with the jump url.
	 *
	 * @param clientID      SSO client ID
	 * @param clientScope   SSO client scope
	 * @param url           base url
	 * @param callback      callback method which takes the following parameters:
	 *                          the jump url to deal with
	 */
	jumpToURL : function( clientID, clientScope, url,  callback) {

		if ( url && callback && clientID && clientScope ) {
			if (window.__adobe_cep__) {
				iaw.cepUtil.getIMSAccessToken( function(token) {
					if ( token ) {
						iaw.cepUtil.createJumpURL(clientID, clientScope, url, callback);
					}
					else {
						iaw.log.console('No jump URL since access token is invalid.');
						callback(url);
					}
				});
			}
			else { // no CEP present
			/*
				$.get('https://'+ getEnvironment().ims +'/ims/jumptoken/v1',
					  {
					  bearer_token:accessToken,
					  target_client_id:'AdobeStockClient1',
					  target_redirect_uri:url,
					  target_scope:'AdobeID,openid,creative_cloud,read_organizations,gnav,additional_info.address.mail_to,sao.stock'
					  })
				.success(function(data) {
						 if (data.jump) {
						 HelloLog.log('jump url:' + data.jump);
						 callback(data.jump);
						 }
						 })
				.error(function(jqXHR, textStatus, errorThrown) {
					   console.log('jump url error: ' + errorThrown);
					   callback(url);
					   });
				*/
			}
		}
	},

	/**
	 * Method to append an external script to the head
	 *
	 * @param script        script path
	 * @return [Promise] promise that will resolve when the script is loaded
	 */
	loadExternalScript : function( script ) {
		return new Promise(function(resolve, reject) {
			var scriptTag = document.createElement('script');
			// setup properties so it's interpreted correctly and loads asynchronously
			scriptTag.type = 'text/javascript';
			scriptTag.charset = 'utf-8';
			// ASYNC: load in parallel and execute as soon as possible
			scriptTag.async = true;
			// DEFER: load in parallel but maintain execution order
			scriptTag.defer = false;
			scriptTag.src = script;
			scriptTag.onload = function() {
				resolve(scriptTag);
			};
			scriptTag.onerror = function(error) {
				reject(error);
			};
			// kick off the load, directly to body so we don't have to traverse to find the head
			document.body.appendChild(scriptTag);
		});
	},

	/**
	 * Format the a Date object in the correct string layout for Radar.
	 * This method is a percaution in case someone changes the required
	 * date format, and we won't need to hunt throught the code to change
	 * all the instances of moment.format
	 *
	 * @param [Date] stamp     Date time stamp to format
	 * @return [String] in the date format YYYY-MM-DDTHH:mm:ss.SSS-XXXX
	 */
	formatTimeStamp: function formatTimeStamp(date) {
		function pad(n, count) {
			count = count || 2;
			var def = '';

			for (var i = 0; i < count; ++i) {
				def += '0';
			}
			return String(def + n).slice(-count);
		}

		var offset = date.getTimezoneOffset();

		return (
			date.getFullYear() +
			'-' +
			pad(date.getMonth() + 1) +
			'-' +
			pad(date.getDate()) +
			'T' +
			pad(date.getHours()) +
			':' +
			pad(date.getMinutes()) +
			':' +
			pad(date.getSeconds()) +
			'.' +
			pad(date.getMilliseconds(), 3) +
			(offset < 0 ? '+' : '-') +
			pad(Math.abs(offset) / 0.6, 4)
		);
	},

	/**
	 * Method to get trial end date.
	 *
	 * @param secondsLeftInTrial      seconds left in trial
	 */
	getTrialEndDate : function( secondsLeftInTrial ) {

		var trialEndDate = new Date(new Date().getTime() + secondsLeftInTrial * 1000);

		return (secondsLeftInTrial >= 0) ? this.formatTimeStamp(trialEndDate) : null;
	},

	/**
	 * Generate a rfc4122 version 4 compliant GUID.
	 * @see http://stackoverflow.com/questions/105034/create-guid-uuid-in-javascript
	 *
	 * @return A string containing the GUID
	 */
	generateGUID : function() {

		/*jshint bitwise: false*/
		return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
			// 'x|0' is a shortcut for 'Math.floor(x)'
			var r = Math.random()*16|0;
			var v = (c === 'x') ? r : (r&0x3|0x8);

			return v.toString(16);
		});
	},

	/**
	 * Open the Library panel to a specific library
	 *
	 * @param The ID of the library you want to show
	 */
	showLibraryInPanel : function( libraryId ) {

		var csInterface = new CSInterface();
		var emitEvent   = function() { //eslint-disable-line func-style
			var setLibEvent = new CSEvent('dlSetCurrentLibrary', 'APPLICATION');

			setLibEvent.data = {'libraryId' : libraryId};
			csInterface.dispatchEvent(setLibEvent);
		};

		var handlePanelInitialized = function() { //eslint-disable-line func-style
			csInterface.removeEventListener('dlPanelInitialized', handlePanelInitialized);
			setTimeout(emitEvent, 200);
		};

		// Emit the event once incase the panel is already open
		emitEvent();

		// Emit the event after panel is initialized
		csInterface.addEventListener('dlPanelInitialized', handlePanelInitialized);

		// Launch the extension incase if it's not already open
		csInterface.requestOpenExtension('com.adobe.DesignLibraries.angular', '');
	},

	/**
	 * Promise helper function
	 *
	 * @param The method you want to use
	 * @param The URL of the service
	 * @param More http headers
	 * @param An array of ignored http status
	 */
	promise : function( method, url, token, headers, ignoredStatus ) {

		return new Promise(function(resolve, reject) {
			var request = new XMLHttpRequest();
			request.open(method, url, true);

			request.onload = function() {
				if (request.status === 200 || request.status === 202) {
					resolve(request.response);
				}
				else if (ignoredStatus && ignoredStatus.indexOf(request.status) > -1) {
					resolve(request.status);
				}
				else {
					reject(request.statusText);
				}
			};

			request.onerror = function() {
				reject(request.statusText || 'Network Error');
			};

			if (token) {
				request.setRequestHeader('x-api-key', 'CCXInAppWelcome');
				request.setRequestHeader('Content-Type', 'application/json');
				request.setRequestHeader('Authorization', 'Bearer ' + token);
				if (headers) {
					Object.keys(headers).forEach(function(key) {
						if (typeof headers[key] !== 'undefined') {
							request.setRequestHeader(key, headers[key]);
						}
					});
				}
			}
			request.send();
		});
	},

	/**
	 * Handle status coming back from the host ExtendScript method,
	 * closes the extension is status is 'true'. Remember callbacks/continuation
	 * methods from ExtendScript always send params as strings.
	 *
	 * @param status       string containing 'false' if cancelled/error, 'true' otherwise
	 */
	closeExtOnStatus: function(status) {
		if ((status.toLowerCase() === 'true') && window.__adobe_cep__) {
			iaw.analytics.ingest.logScreenStateEvent('close-auto');
			iaw.cepUtil.sendEvent(iaw.cepUtil.events.REQUESTHOSTCLOSE, null);
		}
	},

	/**
	 * To be more stringent in adhering to RFC 3986 (which reserves !, ', (, ), and *),
	 * even though these characters have no formalized URI delimiting uses.
	 *
	 * @param str			string to encode
	 * @return String object encoded for URI
	 * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/encodeURIComponent
	 */
	fixedEncodeURIComponent: function(str) {
		var encoded = (str && str.length) ? encodeURIComponent(str).replace(/[!'()*]/g, function(c) {
			return '%' + c.charCodeAt(0).toString(16);
		}) : str;

		return encoded;
	},

	/**
	 * Round to the nearest decimal
	 *
	 * @param {Number} num
	 * @param {Number} decimal - how many decimal places you want to round to
	 * @return {Number} - number rounded to the correct number of decimals
	 */
	roundDecimal: function(num, decimal) {
		return Number(Math.round(Number(num).toFixed(20) + ('e' + decimal)) + ('e-' + decimal));
	},

	/**
	 * Using the ceiling of the closest decimal
	 * Example: ceilDecimal(0.131, 2); // 0.14
	 *
	 * @param {Number} num
	 * @param {Number} decimal - how many decimal places you want to round to
	 * @return {Number} - number rounded to the correct number of decimals
	 */
	ceilDecimal: function(num, decimal) {
		return Number(Math.ceil(Number(num).toFixed(20) + ('e' + decimal)) + ('e-' + decimal));
	},

	/**
	 * Using the floor of the closest decimal
	 * Example: floorDecimal(0.131, 2); // 0.13
	 *
	 * @param {Number} num
	 * @param {Number} decimal - how many decimal places you want to round to
	 * @return {Number} - number rounded to the correct number of decimals
	 */
	floorDecimal: function(num, decimal) {
		return Number(Math.floor(Number(num).toFixed(20) + ('e' + decimal)) + ('e-' + decimal));
	},

	/**
     *
     *
     * @param target 	If string, will mount the tag to first element matched with querySelector; else, assume it's an element
     *
	 */
	mountTag: function(target, tagName, data, animClassIn, animClassOut) {
		data = data || null;
		animClassOut = animClassOut || 'anim--fade-out';
		animClassIn = animClassIn || 'anim--fade-in';

		var parent = target;
		if (typeof parent === 'string') {
			parent = document.querySelector(target);
			if (!parent) {
				console.warn('[iaw.util.mountTag] No element found with selector '+target);
				return;
			}
		}

		function onEnd(evt) {
			// console.log('[mount] onEnd');
			parent.removeEventListener('webkitTransitionEnd', onEnd);
			parent.removeEventListener('webkitAnimationEnd', onEnd);
			parent.removeEventListener('animationend', onEnd);

			parent.classList.remove(animClassOut);
			parent.classList.add(animClassIn);
			riot.mount(parent, tagName, data);
		}

		// just in case it was there
		parent.classList.remove('hidden');
		parent.classList.remove(animClassOut);
		parent.classList.remove(animClassIn);

		if (parent.children.length > 0 || parent.attributes['data-is']) {
			// if there's already something in here, fade it out
			parent.addEventListener('webkitTransitionEnd', onEnd, false);
			parent.addEventListener('webkitAnimationEnd', onEnd, false);
			parent.addEventListener('animationend', onEnd, false);

			parent.classList.add(animClassOut);
		}
		else {
			// animate it in immediately
			parent.classList.add(animClassIn);
			riot.mount(parent, tagName, data);
		}
	},

	/**
     *
     *
     * @param tagInstance
     *
	 */
	unmountTag: function(tagInstance, animClassIn, animClassOut) {
		animClassOut = animClassOut || 'anim--fade-out';
		animClassIn = animClassIn || 'anim--fade-in';
		var parent = tagInstance.root;

		if (parent.classList.contains(animClassOut)) {
			// it's already animating out, so ignore
			return;
		}

		// just in case it was there
		parent.classList.remove(animClassIn);

		function onEnd(evt) {
			// console.log('[unmount] onEnd');
			parent.removeEventListener('webkitTransitionEnd', onEnd);
			parent.removeEventListener('webkitAnimationEnd', onEnd);
			parent.removeEventListener('animationend', onEnd);

			tagInstance.unmount(true);
			parent.removeAttribute('data-is'); // must be a riot bug, because riot should remove this for us
			parent.classList.remove(animClassOut); // clean classList for next time
			parent.classList.add('hidden'); // remove from DOM
		}

		parent.addEventListener('webkitTransitionEnd', onEnd, false);
		parent.addEventListener('webkitAnimationEnd', onEnd, false);
		parent.addEventListener('animationend', onEnd, false);

		parent.classList.add(animClassOut);
	},

	showElement: function(element, animClassIn, animClassOut) {
		animClassOut = animClassOut || 'anim--fade-out';
		animClassIn = animClassIn || 'anim--fade-in';

		// just in case it was there
		element.classList.remove('hidden');
		element.classList.remove(animClassOut);
		element.classList.remove(animClassIn);

		element.classList.add(animClassIn);
	},

	hideElement: function(element, animClassIn, animClassOut) {
		animClassOut = animClassOut || 'anim--fade-out';
		animClassIn = animClassIn || 'anim--fade-in';

		// just in case it was there
		element.classList.remove(animClassOut);
		element.classList.remove(animClassIn);

		function onEnd(evt) {
			element.removeEventListener('webkitTransitionEnd', onEnd);
			element.removeEventListener('webkitAnimationEnd', onEnd);
			element.removeEventListener('animationend', onEnd);
			element.classList.add('hidden'); // remove from DOM
		}

		element.addEventListener('webkitTransitionEnd', onEnd, false);
		element.addEventListener('webkitAnimationEnd', onEnd, false);
		element.addEventListener('animationend', onEnd, false);

		element.classList.add(animClassOut);
	},

	/**
     * Convert a country code to a shared cloud useable region
     *
     * @param countryCode    country code
     * @return two digit region used in shared cloud call
     *
	 */
	getRegionFromCountryCode: function(countryCode) {
		return iaw.util.countryCodeMap[countryCode];
	},
	// keep this outside so it's only created once per app session, not once every time the function is called, or else we'll have a memory problem
	countryCodeMap: {'US': 'us', 'CA': 'us', 'AI': 'us', 'AG': 'us', 'AR': 'us', 'AW': 'us', 'BS': 'us', 'BB': 'us', 'BZ': 'us', 'BM': 'us', 'BO': 'us', 'BR': 'us', 'KY': 'us', 'CL': 'us', 'CO': 'us', 'CR': 'us', 'DM': 'us', 'DO': 'us', 'EC': 'us', 'SV': 'us', 'FK': 'us', 'GF': 'us', 'GD': 'us', 'GP': 'us', 'GT': 'us', 'GY': 'us', 'HT': 'us', 'HN': 'us', 'JM': 'us', 'MQ': 'us', 'MX': 'us', 'MS': 'us', 'AN': 'us', 'NI': 'us', 'PA': 'us', 'PY': 'us', 'PE': 'us', 'KN': 'us', 'LC': 'us', 'PM': 'us', 'VC': 'us', 'GS': 'us', 'SR': 'us', 'TT': 'us', 'TC': 'us', 'UM': 'us', 'UY': 'us', 'VE': 'us', 'VG': 'us', 'AS': 'us', 'PR': 'us', 'GB': 'eu', 'AL': 'eu', 'DZ': 'eu', 'AD': 'eu', 'AO': 'eu', 'AM': 'eu', 'AT': 'eu', 'AZ': 'eu', 'BY': 'eu', 'BE': 'eu', 'BJ': 'eu', 'BA': 'eu', 'BW': 'eu', 'IO': 'eu', 'BG': 'eu', 'BF': 'eu', 'BI': 'eu', 'CM': 'eu', 'CV': 'eu', 'CF': 'eu', 'TD': 'eu', 'KM': 'eu', 'CD': 'eu', 'CG': 'eu', 'HR': 'eu', 'CY': 'eu', 'CZ': 'eu', 'DK': 'eu', 'DJ': 'eu', 'EG': 'eu', 'GQ': 'eu', 'ER': 'eu', 'EE': 'eu', 'ET': 'eu', 'FO': 'eu', 'FI': 'eu', 'FR': 'eu', 'GA': 'eu', 'GM': 'eu', 'GE': 'eu', 'DE': 'eu', 'GH': 'eu', 'GI': 'eu', 'GR': 'eu', 'GL': 'eu', 'GN': 'eu', 'GW': 'eu', 'HU': 'eu', 'IS': 'eu', 'IE': 'eu', 'IT': 'eu', 'CI': 'eu', 'KE': 'eu', 'LV': 'eu', 'LS': 'eu', 'LR': 'eu', 'LY': 'eu', 'LI': 'eu', 'LT': 'eu', 'LU': 'eu', 'MK': 'eu', 'MG': 'eu', 'MW': 'eu', 'ML': 'eu', 'MT': 'eu', 'MR': 'eu', 'MU': 'eu', 'YT': 'eu', 'MD': 'eu', 'MC': 'eu', 'ME': 'eu', 'MA': 'eu', 'MZ': 'eu', 'NA': 'eu', 'NL': 'eu', 'NE': 'eu', 'NG': 'eu', 'NO': 'eu', 'PS': 'eu', 'PL': 'eu', 'PT': 'eu', 'RE': 'eu', 'RO': 'eu', 'RW': 'eu', 'SH': 'eu', 'SM': 'eu', 'ST': 'eu', 'SN': 'eu', 'CS': 'eu', 'RS': 'eu', 'SC': 'eu', 'SL': 'eu', 'SK': 'eu', 'SI': 'eu', 'SO': 'eu', 'ZA': 'eu', 'ES': 'eu', 'SJ': 'eu', 'SZ': 'eu', 'SE': 'eu', 'CH': 'eu', 'TZ': 'eu', 'TG': 'eu', 'TN': 'eu', 'UG': 'eu', 'UA': 'eu', 'VA': 'eu', 'EH': 'eu', 'ZM': 'eu', 'ZW': 'eu', 'AF': 'ap', 'AQ': 'ap', 'AU': 'ap', 'BH': 'ap', 'BD': 'ap', 'BT': 'ap', 'BN': 'ap', 'MM': 'ap', 'KH': 'ap', 'CN': 'ap', 'CX': 'ap', 'CC': 'ap', 'CK': 'ap', 'TL': 'ap', 'FJ': 'ap', 'PF': 'ap', 'HK': 'ap', 'IN': 'ap', 'ID': 'ap', 'IQ': 'ap', 'IL': 'ap', 'JP': 'ap', 'JO': 'ap', 'KZ': 'ap', 'KI': 'ap', 'KR': 'ap', 'KW': 'ap', 'KG': 'ap', 'LA': 'ap', 'LB': 'ap', 'MO': 'ap', 'MY': 'ap', 'MV': 'ap', 'MH': 'ap', 'FM': 'ap', 'MN': 'ap', 'NR': 'ap', 'NP': 'ap', 'NC': 'ap', 'NZ': 'ap', 'NU': 'ap', 'NF': 'ap', 'OM': 'ap', 'PK': 'ap', 'PG': 'ap', 'PH': 'ap', 'PN': 'ap', 'QA': 'ap', 'RU': 'ap', 'WS': 'ap', 'SA': 'ap', 'SG': 'ap', 'SB': 'ap', 'LK': 'ap', 'TW': 'ap', 'TJ': 'ap', 'TH': 'ap', 'TK': 'ap', 'TO': 'ap', 'TR': 'ap', 'TM': 'ap', 'TV': 'ap', 'AE': 'ap', 'UZ': 'ap', 'VU': 'ap', 'VN': 'ap', 'WF': 'ap', 'YE': 'ap'},

	hashStr: function(str) {
		var hash = 0, i, chr, len;
		if (str.length === 0) return hash;
		for (i = 0, len = str.length; i < len; i++) {
			chr = str.charCodeAt(i);
			hash = ((hash << 5) - hash) + chr;
			hash |= 0; // convert to 32bit integer
		}
		return hash;
	},

	/**
	 * Convert the file size into a formatted string.
	 *
	 * @param isize			integer value of file size
	 * @return A string formatted with the size MB/GB/KB etc. specifier
	 */
	createFileSizeString: function(isize) {
		var val = '';

		if (isize >= 1099511627776) { // TB
			val = ((isize / 1099511627776).toFixed(1)).toString()+iaw.i18n.getLocalizedString('filesize_key_TB');
		}
		else if (isize >= 1073741824) { // GB
			val = ((isize / 1073741824).toFixed(1)).toString()+iaw.i18n.getLocalizedString('filesize_key_GB');
		}
		else if (isize >= 1048576) { // MB
			val = ((isize / 1048576).toFixed(1)).toString()+iaw.i18n.getLocalizedString('filesize_key_MB');
		}
		else if (isize >= 1024) { // KB
			val = ((isize / 1024).toFixed(1)).toString() + iaw.i18n.getLocalizedString('filesize_key_KB');
		}
		else if (isize > 0) { // Bytes
			val = isize.toString()+iaw.i18n.getLocalizedString('filesize_key_B');
		}
		else {
			val = '--';
		}

		return val.replace('.', iaw.i18n.getLocalizedString('filesize_key_decimal'));
	},

	/**
	 * Show license dialog.
	 *
	 * @param element	element {type: 'application/vnd.adobe.element.template+dcx'}
	 * @param contentId template Id
	 * @skipQuotaCheck 	skip quota check
	 * @licenseType 	license type
	 */
	showLicenseDialog: function(element, contentId, skipQuotaCheck, libraryId, renditionDetails, licenseType) {
		var PURCHASE_DIALOG_INIT_EVENT_NAME = 'com.adobe.stock.panel.license.init';
		var PURCHASE_DIALOG_PERFORM_EVENT_NAME = 'com.adobe.stock.panel.license.perform';
		var PURCHASE_DIALOG_CLOSED_EVENT_NAME = 'com.adobe.stock.panel.license.closed';
		var PURCHASE_DIALOG_EXTENSION_ID = 'com.adobe.stock.panel.licensing';

		return new Promise(function(resolve, reject) {
			var csInterface = iaw.cepUtil.csInterface;
			if (!csInterface) {
				reject();
				return;
			}
			// Register for event to know when Purchase dialog loads & pass on the required information
			function onPurchaseDialogInit(event) {
				csInterface.removeEventListener(PURCHASE_DIALOG_INIT_EVENT_NAME, onPurchaseDialogInit);
				var csEvent = new CSEvent(PURCHASE_DIALOG_PERFORM_EVENT_NAME, 'APPLICATION', 'CCInAppCmdN', csInterface.getExtensionID());
				// TODO: get rid of stockSearchAsset once Stock search is working fine
				csEvent.data = {'elementType': element.type, 'contentId': String(contentId), 'skipQuotaCheck': skipQuotaCheck, 'licenseType': licenseType, 'addToLibraryID': libraryId, 'renditionDetails': renditionDetails};
				csInterface.dispatchEvent(csEvent);
				iaw.log.logJSON('Dispatch CEP event to start purchase dialog: ', csEvent);
			}
			csInterface.addEventListener(PURCHASE_DIALOG_INIT_EVENT_NAME, onPurchaseDialogInit);

			// Register for event to know when Purchase dialog closes & get purchase information
			function onPurchaseDialogClosed(event) {
				iaw.log.logJSON('Data from purchase dialog: ', event);
				csInterface.removeEventListener(PURCHASE_DIALOG_CLOSED_EVENT_NAME, onPurchaseDialogClosed);
				csInterface.removeEventListener('com.adobe.csxs.events.ExtensionUnloaded', onPurchaseDialogClosed);

				// If this callback is due to ExtensionUnloaded event
				if (event.type === 'com.adobe.csxs.events.ExtensionUnloaded') {
					var xmlParser = new DOMParser();
					var xmlDoc = xmlParser.parseFromString(event.data, 'text/xml');
					// Check for the extension that go unloaded
					if (xmlDoc.getElementsByTagName('Id')[0].childNodes[0].nodeValue !== PURCHASE_DIALOG_EXTENSION_ID) {
						return;
					}
				}

				var eventData = event.data;
				if (eventData && eventData.didFinish) {
					resolve(eventData.data);
				}
				else {
					reject(eventData && eventData.data);
				}
			}
			csInterface.addEventListener(PURCHASE_DIALOG_CLOSED_EVENT_NAME, onPurchaseDialogClosed);
			csInterface.addEventListener('com.adobe.csxs.events.ExtensionUnloaded', onPurchaseDialogClosed);

			csInterface.requestOpenExtension(PURCHASE_DIALOG_EXTENSION_ID);
		});
	},

	/**
	 * Creates a string like "ccx.open recent grid" or "ccx.start dragdrop" to pass to Photoshop
	 * for Highbeam logging of open actions.
	 *
	 * @param context			The general context such as recent, cc files, open dialog, etc
	 * @param contextDetails	More details about the context, e.g. grid or list view. Optional.
	 * @return A string combining the telling part of the extension id and the contet and details.
	 */
	getPipMethodString : function(context, viewMode) {
		var method = iaw.cepUtil.csInterface.getExtensionID().replace('com.adobe.', '') + ' ' + context;
		if (viewMode) {
			method += ' ' + viewMode;
		}
		return method;
	},

	/**
	 * Object.assing polyfill from https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/assign
	 */
	assign: function(target) {
		'use strict';
		if (target === undefined || target === null) {
			throw new TypeError('Cannot convert undefined or null to object');
		}

		var output = Object(target);
		for (var index = 1; index < arguments.length; index++) {
			var source = arguments[index];
			if (source !== undefined && source !== null) {
				for (var nextKey in source) {
					if (source.hasOwnProperty(nextKey) && source[nextKey] !== undefined) {
						output[nextKey] = source[nextKey];
					}
				}
			}
		}
		return output;
	},

	/**
	 * Merges two (or more) objects, giving the last one precedence
	 * @param {Object} target
	 * @param {Object} source
	 */
	merge: function(target, source) {
		if (typeof target !== 'object') {
			target = {};
		}

		var sourceProperty;

		for (var property in source) {
			if (source.hasOwnProperty(property)) {
				sourceProperty = source[property];

				if (typeof sourceProperty === 'object') {
					target[property] = iaw.util.merge(target[property], sourceProperty);
				}

				target[property] = sourceProperty;
			}
		}

		for (var a = 2, l = arguments.length; a < l; a++) {
			iaw.util.merge(target, arguments[a]);
		}

		return target;
	},


	/**
	 * Get template data per template id
	 * @param templateId		template id
	 * @return A object of template data
	 */
	getTemplateData: function(templateId) {
		var templateData;
		var templates = iaw.store.get('templates');
		if (templates && templates.length > 0) {
			templates.forEach(function(template) {
				if (template.id === templateId) {
					templateData = template;
				}
			});
		}
		return templateData;
	},

	/**
	 * Set template data per uuid
	 * @param templateId		template id
	 * @return A object of template data
	 */
	setTemplateData: function(uuid, templateData) {
		var templateIndex = iaw.store.get(['templateLUT', uuid]);
		iaw.store.set(['templates', templateIndex], templateData);
	},

	/**
	 * Animate a scrollTo action of the provided element given the provided offset
	 * TODO this should move to a more common location, perhaps with spectre if this disclosure widget makes it there
	 *
	 * @param {DOM.element} element scroll container element
	 * @param {number} offset positive or negative distance to scroll from current
	 * @param {number=} duration
	 * @param {Function=} callback
	 */
	smoothScroll: function(element, offset, duration, callback) {

		function easeInOutQuad(t, b, c, d) {
			t /= d/2;
			if (t < 1) {
				return c/2*t*t + b;
			}
			t--;
			return -c/2 * (t*(t-2) - 1) + b;
		}

		var start = element.scrollTop,
			currentTime = 0,
			increment = 20,
			val;

		duration = (typeof (duration) === 'undefined') ? 500 : duration;

		function animateScroll() {
			currentTime += increment;
			val = easeInOutQuad(currentTime, start, offset, duration);
			element.scrollTop = val;

			if (currentTime < duration) {
				requestAnimationFrame(animateScroll);
			}
			else if (typeof callback === 'function') {
				callback();
			}
		}

		animateScroll();
	},

	/**
	 * Launch CCX process if not running.
	 * callback is a funcion with parameter status code:
	 *   0: means the process has been running
	 *   1: indicates the process is just launched and ready
	 *   2: timeout or failed to launch process, like Thor is upgrading, or it's slow to get CCX Process startup (longer than 2 seconds)
	 *   3: Thor or ccx process is not installed at all
	 */
	launchCCXProcess: function(callback) {
		if (iaw.util.ccxProcessLaunchPending || !window.__adobe_cep__) {
			return;
		}

		var initializedTimeout;
		var initializedMessage = 'vulcan.SuiteMessage.ccxprocess.Initialized';

		callback = callback || function() {};
		iaw.util.ccxProcessLaunchPending = true;

		function onFinished(status) {
			callback(status);
			iaw.util.ccxProcessLaunchPending = false;
		}

		function started() {
			clearTimeout(initializedTimeout);
			iaw.util.ccxProcessLaunchPending = false;
			VulcanInterface.removeMessageListener(initializedMessage, started);
			onFinished(1);
		}

		function startLaunchCCXProcess() {
			VulcanInterface.addMessageListener(initializedMessage, started);
			initializedTimeout = setTimeout(function() {
				VulcanInterface.removeMessageListener(initializedMessage, started);
				onFinished(2);
			},
			1000);
			VulcanInterface.launchApp('ccxprocess', false);
		}

		if (VulcanInterface.isAppInstalled('ccxprocess')) {
			iaw.util.isCCXProcessRunning(function(isRunning) {
				if (!isRunning) {
					iaw.log.console('Start to launch CCX Process');
					startLaunchCCXProcess();
				}
				else {
					onFinished(0);
				}
			});
		}
		else {
			onFinished(3);
		}
	},

	/**
	 * Check if CCX process is installed.
	 */
	isCCXProcessInstalled: function(callback) {
		return VulcanInterface.isAppInstalled('ccxprocess');
	},

	/**
	 * Check if CCX process is running.
	 */
	isCCXProcessRunning: function(callback) {
		if (!iaw.util.isWindowsOS() && VulcanInterface.isAppRunning('ccxprocess')) {
			// Ignore VulcanInterface.isAppRunning on Windows due to https://jira.corp.adobe.com/browse/CEP-510
			return callback(true);
		}

		// VulcanInterface.isAppRunning is not reliable to know the running status. Sometimes it returns false for the running CCX Process on Mac.
		// Workaround is to check if CCX Process is able to respond to a ping/pong message in 200ms.
		var pingMessage = 'vulcan.SuiteMessage.ccxprocess.in.request.app.ping';
		var pongMessage = 'vulcan.SuiteMessage.ccxprocess.out.response.app.ping';
		var pingMessageTimeout;

		function pongHanlder() {
			clearTimeout(pingMessageTimeout);
			VulcanInterface.removeMessageListener(pongMessage, pongHanlder);
			callback(true);
		}

		VulcanInterface.addMessageListener(pongMessage, pongHanlder);
		pingMessageTimeout = setTimeout(function() {
			VulcanInterface.removeMessageListener(pongMessage, pongHanlder);
			callback(false);
		}, 200);

		var message = new VulcanMessage(pingMessage);
		message.setPayload('');
		VulcanInterface.dispatchMessage(message);
	}
};
